import React from "react";
import SaitRowActionCell from "./SaitRowActionCell.jsx";

export default function SaitRowAction(props) {
	return {
		headerName: "",
		field: props.id,
		objmod: props.objmod,
		width: 45,
		minWidth: 40,
		actionColumn: true,
		sortable: false,
		resizable: false,
		disableColumnMenu: false,
		display: "flex",
		hidden: props.hidden,
		endPinned: props.endPinned !== undefined ? props.endPinned : true,
		startPinned: props.startPinned,
		renderCell: (params) => <SaitRowActionCell config={props} params={params} />,
		//Estratto in componente separato per evitare di chiamare Hook (es: useSelector/useContext) all'interno di un eventuale ciclo
	};
}
